import { useNavigate } from "react-router-dom";
import I18n from "i18n-js";
import Constants from "common/constant";
import { btnDelay, usePlaySound } from "common/utils";
import { Footer } from "features/home";
import { SSO } from "./SSO";
import { BackBtn } from "./BackBtn";

export const LoginScreen = () => {
  const navigate = useNavigate();
  const playSound = usePlaySound();

  const handleEmailLogin = () => {
    btnDelay(() => {
      playSound();
      navigate("/auth/email-login");
    });
  };

  return (
    <div className="flex-col-el flex-center relative overflow-hidden w-full h-full p-6">
      <img
        alt="*"
        src={`${Constants.assetHost}/assets/images/new_bg_puzzle.png`}
        className="absolute inset-0 object-cover w-full h-full z-[-1]"
      />

      <BackBtn />
      <div className="flex-col-el flex-center w-full max-w-md mx-auto">
        <div className="flex-col-el flex-center p-6 w-full">
          <div className="flex-col-el flex-center">
            <p className="text-body text-3xl !mb-6 text-center text-textcolor-black">
              {I18n.t("MSG_SIGN_IN_BTN")}
            </p>
          </div>

          <div className="flex-col-el flex-center max-w-sm w-full gap-4 upsilon">
            <button
              className="btn btn-primary w-[375px] h-[40px]"
              onClick={handleEmailLogin}
            >
              <p className="text-body text-base">
                {I18n.t("MSG_SIGN_IN_WITH_MAIL")}
              </p>
            </button>
            <SSO signIn={true} />
          </div>

          {/* フッターオプション */}
          <div className="upsilon flex justify-center mt-4">
            <button
              className="btn btn-primary-outlined"
              onClick={() => {
                btnDelay(() => {
                  playSound();
                  navigate("/auth/register");
                });
              }}
            >
              <p className="text-body text-sm">
                {I18n.t("MSG_SIGN_NO_ACCOUNT_REGISTER")}
              </p>
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};
